import React from "react";
export default function ProfileInput({
  type,
  name,
  id,
  placeholder,
  errors = [],
  label,
  defaultValue = "",
  disabled,
  inputClass = "",
  showLabel = true,
  register = () => {},
  dark = false,
}) {
  return (
    <div className="w-full flex flex-col">
      {showLabel && (
        <label className={`mb-1 text-sm font-medium ${dark ? "text-zinc-300" : "text-black"}`}>
          {label}
        </label>
      )}
      <input
        disabled={disabled}
        defaultValue={defaultValue}
        type={type}
        id={id}
        placeholder={placeholder}
        className={`w-full rounded-md mt-1 border transition-colors duration-200 p-3 text-sm focus:outline-none 
          ${
            dark
              ? "bg-zinc-900 border-zinc-800 text-white placeholder-zinc-500 hover:border-secondary focus:border-secondary active:border-secondary disabled:bg-zinc-950 disabled:text-zinc-500 disabled:border-zinc-900/50"
              : "bg-white border-gray-200 text-black placeholder-gray-400 hover:border-secondary focus:border-secondary active:border-secondary disabled:bg-gray-100 disabled:text-gray-400"
          } ${inputClass}`}
        {...register(name)}
      />
      {errors[name] && (
        <p className="text-red-500 mt-2 text-xs md:text-sm text-left ml-1 font-medium">
          {errors[name]?.message}
        </p>
      )}
    </div>
  );
}
